import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  BusinessPage,
  Footer,
  NavBar,
  Grid,
  ThemeWrapper,
  DataFetching,
} from "./components";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ReactGA from "react-ga";

ReactGA.initialize("UA-123995183-6");

export default function App() {
  return (
    <Router onUpdate={() => window.scrollTo(0, 0)}>
      <ScrollToTop />
      <ThemeWrapper>
        <NavBar />

        <DataFetching>
          {(props) => (
            <Switch>
              <Route path="/business/:slug" exact>
                <BusinessPage {...props} />
              </Route>
              <Route path="/:location?">
                <Grid {...props} />
              </Route>
            </Switch>
          )}
        </DataFetching>

        <Footer />
      </ThemeWrapper>
    </Router>
  );
}
